module.exports = __webpack_public_path__ + "images/triangle_bordered.png";